module.exports = __webpack_public_path__ + "media/marketing_area/Vendors_Dynamic_Products_1-935ac030.jpg";